import { db } from './firestore';
import { collection, getDocs, doc, setDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import logger from '../utils/logger';
import { USE_CONTRACTS_V2 } from './contractsV2';
import { finesService, officeError } from './finesService';

const companiesCollection = collection(db, 'companies');

// With the new store (USE_CONTRACTS_V2) the corporate customers are the engine's office records
// (/api/office/companies): the same {id, name, address, trn, email, phone} records sorted by name; a save merges
// into the company (a new one's id is its name lower-cased with _ for spaces - the rule below, applied by the
// server) and the store stamps last_updated itself.

export const companyService = {
    getAllCompanies: async () => {
        try {
            if (USE_CONTRACTS_V2) return (await finesService.officeCompanies()) || [];
            const q = query(companiesCollection, orderBy('name', 'asc'));
            const snapshot = await getDocs(q);
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        } catch (error) {
            logger.error('Error getting companies:', error);
            return [];
        }
    },

    saveCompany: async (company) => {
        try {
            const companyId = company.id || company.name.replace(/\s+/g, '_').toLowerCase();
            if (USE_CONTRACTS_V2) {
                const saved = await finesService.officeCompanySave({
                    id: companyId,
                    name: company.name,
                    address: company.address || '',
                    trn: company.trn || '',
                    email: company.email || '',
                    phone: company.phone || ''
                }).catch((e) => { throw officeError(e); });
                return { success: true, id: saved?.id || companyId };
            }
            const docRef = doc(companiesCollection, companyId);
            const data = {
                name: company.name,
                address: company.address || '',
                trn: company.trn || '',
                email: company.email || '',
                phone: company.phone || '',
                last_updated: new Date().toISOString()
            };
            await setDoc(docRef, data, { merge: true });
            return { success: true, id: companyId };
        } catch (error) {
            logger.error('Error saving company:', error);
            return { success: false, error };
        }
    },

    deleteCompany: async (id) => {
        try {
            if (USE_CONTRACTS_V2) {
                // a company already gone is what the delete wanted (Firestore's deleteDoc of a missing doc succeeds too)
                await finesService.officeCompanyDelete(id).catch((e) => {
                    if (e?.response?.status !== 404) throw officeError(e);
                });
                return { success: true };
            }
            await deleteDoc(doc(companiesCollection, id));
            return { success: true };
        } catch (error) {
            logger.error('Error deleting company:', error);
            return { success: false, error };
        }
    }
};
